export default __webpack_public_path__ + "static/media/video_cinema.8c91cb68.MP4";